var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M41.24 6.76H6.76v34.48h34.48zM24.122 6.984v34.255M6.76 24.112h34.48M28.411 29.993h9.036M28.411 34.334h9.036M10.401 15.887h9.036"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M33.167 11.375V20.4M28.655 15.887h9.035M11.72 29.932l6.388 6.39M18.108 29.932l-6.389 6.39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h36v36H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.78d9a9cf336ec06eb1cf7e023f223391.svg";
export { ForwardRef as ReactComponent };